/* eslint-disable camelcase */
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  title: {
    fontSize: 12,
    color: '#1e3f9e',
    maxWidth: 650,
  },
  list: {
    fontSize: 12,
  },
}));

const Settings = () => {
  const classes = useStyles();
  return (
    <div>
      <h4 className={classes.title}> Open the Tera Term application.</h4>
      <h4 className={classes.title}>
        If this is your first time adding a monitor, follow the steps below to set up a connection to your monitor. If
        you have already completed these steps in a previous session, press CONTINUE.
      </h4>
      <ol className={classes.list}>
        <li>If a connection popup window is present, close the popup</li>
        <li>From the menu, select Setup &#8594; Serial port</li>
        <li>
          Change the Speed setting to 230400, and ensure the Port is set to the serial port to which your monitor is
          connected
        </li>
        <li>Click 'New open' to initialize the connection</li>
        <li>To save these settings for future uses, select from the menu Setup &#8594; Save setup, and press Save</li>
      </ol>
    </div>
  );
};

export default Settings;
